import { eventDescriptionAsHtml } from "@sp-crm/core";
import sanitizeHtml from "sanitize-html";

export const eventDescriptionHtml = eventDescriptionAsHtml;

export const editorDescriptionOrNull = (content: string): string | null => {
    const text = sanitizeHtml(content, { allowedTags: [], allowedAttributes: {} })
        .replace(/&nbsp;/g, " ")
        .trim();
    return text === "" ? null : content;
};
